import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export interface EmptyVisitasStateProps {
  onAddFirstVisita?: () => void;
  addVisitaLoading?: boolean;
  isAdmin?: boolean;
}

const MESSAGE =
  "Nenhuma vista cadastrada. Adicione a primeira vista para começar o diário de obra.";

export default function EmptyVisitasState({
  onAddFirstVisita,
  addVisitaLoading = false,
  isAdmin = false,
}: EmptyVisitasStateProps) {
  return (
    <Card>
      <CardContent className="text-center py-12">
        <p className="text-primary-600 dark:text-primary-400 mb-6">{MESSAGE}</p>
        {isAdmin && onAddFirstVisita && (
          <Button
            type="button"
            onClick={onAddFirstVisita}
            disabled={addVisitaLoading}
          >
            {addVisitaLoading ? "ADICIONANDO..." : "ADICIONAR PRIMEIRA VISTA"}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
